import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { QUERY_DASHBOARD_MARK_RULES } from '../graphql/queries/dashboard/queryDashboardMarkRules';
import { QueryDashboardMarkRulesResponse } from '../graphql/types/dashboard/DashboardMarkRuleTypes';
import { buildMarkRuleContext, MarkRuleContext } from '../utils/dashboardMarkRule';

/**
 * 加载看板标记规则并预计算为查表上下文。
 *
 * @param dashboardKey common_config 的 configKey，取 DASHBOARD_MARK_CONFIG_KEY 常量
 * @param enabled 是否启用标记（非「日」粒度时传 false）
 */
export function useDashboardMarkRules(dashboardKey: string, enabled: boolean): MarkRuleContext {
    const { data } = useQuery<QueryDashboardMarkRulesResponse>(QUERY_DASHBOARD_MARK_RULES, {
        variables: { dashboardKey },
        fetchPolicy: 'cache-first',
    });

    return useMemo(
        () => buildMarkRuleContext(data?.queryDashboardMarkRules, enabled),
        [data, enabled]
    );
}
